import api from './api'; // Import Axios instance


export const getAllAwaitingChats = async () => {
    try {
        const response = await api.get('/chat/awaiting-admin/');

        const pendingChatData = response.data.payload;
        return pendingChatData;

    } catch (error) {
        console.error('Failed to get pending chats');
        throw error;
    }
};


export const getAllOngoingChats = async () => {
    try {
        const response = await api.get('/chat/ongoing/');

        const ongoingChatData = response.data.payload;
        return ongoingChatData;

    } catch (error) {
        console.error('Failed to get ongoing chats');
        throw error;
    }
};

export const getChatMessages = async (chatId, batchNumber) => {
    try {
        const postRequest = await api.get(`/chat/${chatId}/messages/${batchNumber}`);
        const response = postRequest.data.payload;
        return response;
    } catch (error) {
        console.error('Failed to get chat messages for chat ' + chatId);
        throw error;
    }
}

export const adviserJoinChat = async (userChatId) => {
    try {
        const postRequest = await api.post(`/chat/admin/create-session?userChatId=${userChatId}`);

        const response = postRequest;
        return response;

    } catch (error) {
        console.error('Failed to join room');
        throw error;
    }
};